var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td-login',{attrs:{"sPlatformFlg":_vm.sPlatformFlg,"systemName":_vm.systemName},on:{"loginSucess":_vm.loginSucess}})
}
var staticRenderFns = []

export { render, staticRenderFns }